import React from 'react';

const CustomText = ({
  placeholder, 
  fontSize = '2vh',    
  borderRadius = '20px',  
  onChange,
  onKeyDown
}) => {
  
  const style = {
    width: '60vw',
    fontSize: fontSize,
    borderRadius: borderRadius,
    padding: '12px',
    backgroundColor: '#555',
    color: 'white',
    border: '1px solid #555',
    outline: 'none',
    boxSizing: 'border-box',
    fontFamily: 'inherit',
    marginTop: '3.5vh'
  };

  return (
    <input 
      type="text"
      placeholder={placeholder}
      style={style}
      onChange={onChange}
      onKeyDown={onKeyDown}
    />
  );
};

export default CustomText;